import {VarDeclChunk} from "../../chunks/types/VarDeclChunk";
import {getNameFromIdentifierChunk} from "./getNameFromIdentifier";

export function getVarNameFromVarDeclChunk(
  varDeclChunk: VarDeclChunk
): string {
  const {
    captures: {
      1: varNameChunk
    }
  } = varDeclChunk;
  return getNameFromIdentifierChunk(varNameChunk);
}
